import React from 'react';
import ModalWrapper from './ModalWrapper';
import { formatNumber } from './utils';

export default function QtyConfirmationModal({ open, onClose, qty, item, booking }) {
  return (
    <ModalWrapper open={open} onClose={onClose}>
      <div style={{ textAlign: 'center', minWidth: 320 }}>
        <h2 style={{ color: '#1976d2', marginBottom: 12 }}>Booking Confirmed!</h2>
        <div style={{ fontSize: 18, marginBottom: 18 }}>
          Remaining stock for <b>{item?.mainCategory || item?.description || item?.productCode}</b>:
          <div style={{ fontSize: 32, fontWeight: 700, color: qty > 0 ? '#1976d2' : '#b71c1c', marginTop: 6 }}>{formatNumber(qty)}</div>
        </div>
        <button onClick={onClose} style={{ background: '#1976d2', color: '#fff', padding: '10px 32px', borderRadius: 8, border: 'none', fontWeight: 700, fontSize: 16, marginTop: 12 }}>OK</button>
      </div>
    </ModalWrapper>
  );
}
